<template>
  <component :is="currentComponent" :param="componentParams"/>
</template>
<script>

import commonMixin from '@/mixin/commonMixin'
import AttendAuth from '@/components/pages/nrw/attend/AttendAuth'
import AttendTimeCheck from '@/components/pages/nrw/attend/AttendTimeCheck'

export default {
  name: 'AttendMainAuth',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: QR출석체크 분기'
    }
  },
  components: {
    AttendAuth,
    AttendTimeCheck
  },
  mixins: [commonMixin],
  data () {
    return {
      currentComponent: null,
      componentParams: {},
      params: {
        eduGrpCd: this.$route.query.eduGrpCd || 'CUS0001',
        corsCd: this.$route.query.corsCd,
        corsYr: this.$route.query.corsYr,
        corsDgrCd: this.$route.query.corsDgrCd,
        clssDgr: this.$route.query.clssDgr || '1',
        lrnYmd: '',
        schdlSno: '',
        mbrNo: '',
        langCd: this.getUserLangCd()
      },
      corsInfo: {}
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    this.selectQrCors()
  },
  beforeDestroy () {
  },
  mounted () {
  },
  methods: {
    selectQrCors () {
      const params = {...this.params}
      this.$http.b2c.selectQrCors(this, params).then(result => {
        if (result.data.status === 'OK') {
          this.componentParams.corsInfo = {...result.data.data.corsInfo}
          this.currentComponent = AttendAuth
        } else {
          if (result.data.code === 'ATTENDANCE_VALIDATION_TIME_ERROR') {
            this.componentParams.corsTimeChk = 'N'
          }

          this.currentComponent = AttendTimeCheck
        }
      }).catch(err => {
        console.log(err.message)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/attend/AttendMain.vue